<div class="content-compact"
[ngClass]="AppSettings.IsRunningInSingularity ? 'content-compact-sso' : ''">
  <div class="consoleHeader "
  [ngClass]="AppSettings.IsRunningInSingularity ? 'consoleHeader-sso' : ''">
    <div class="row flex-nowrap" style="height: 100%;">
      <div class="col-auto d-flex align-items-center header_section">
        <div class="col-auto mr-2">
          <div ngbDropdown class="">
              <button class="btn btn-link btn-nonlink p-0 mr-2" id="selSort" ngbDropdownToggle
                      title="{{'BTN.BTN_SORT_BY' | translate}}" translate>
                  ENTITIES.ENTITIES_STATUS
              </button>
            <div ngbDropdownMenu aria-labelledby="selSort">
              <button *ngFor="let item of Status_List" class="dropdown-item pointer"
                [ngClass]="{'active': item.Id == RequestModel.DeviceStatus}"
                (click)="OnFilter(item)" translate>{{item.Name}}</button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-auto d-flex align-items-center header_section">
        <div class="searchFilterResult">
          <input type="text" [(ngModel)]="deviceSearchResult.RequestModel.Keyword"
            (keyup)="deviceSearchResult.FilterData()" class="form-control searchFilter_Text" />
        </div>
      </div>



      <div class="col d-flex justify-content-end">
        <div class="col-auto d-flex align-items-center header_section">
            <button type="button" class="btn btn-primary"
                    *ngIf="deviceSearchResult.FilteredData && deviceSearchResult.FilteredData.length > 0"
                    (click)="DeactivateAllDevices()" translate>BTN.BTN_DEACTIVATE_ALL
            </button>
          <button type="button" class="btn btn-default"
            *ngIf="!deviceSearchResult.FilteredData || deviceSearchResult.FilteredData.length <= 0"
            [disabled]="true" translate>BTN.BTN_DEACTIVATE_ALL</button>
        </div>
        <div class="header_section align-items-center px-3">
          <div class="pointer" (click)="RefreshData()" title="{{'TITLE.TITLE_REFRESH' | translate}}"><i
              class="fa fa-lg fa-sync-alt"></i></div>
        </div>
      </div>
    </div>
  </div>

  <div class="jobconsole-body">
     
    <div>
      <DeviceSearchResult #deviceSearchResult [RequestModel]="RequestModel">
      </DeviceSearchResult>
    </div>
  </div>

</div>
